import { FC } from 'react'
import GradientSection from '../../../shared/components/GradientSection'

const items = [
  {
    itemTitle: 'Clarity powers confidence',
    itemDescription:
      'When people understand where they stand and what their options mean, they can move forward decisively.',
  },
  {
    itemTitle: 'Potential is always evolving',
    itemDescription: 'Growth and possibility extend beyond any single number or snapshot in time.',
  },
  {
    itemTitle: 'Progress should be visible',
    itemDescription:
      'Progress becomes meaningful when it is recognized and translated into real value.',
  },
  {
    itemTitle: 'Time is a valuable resource',
    itemDescription:
      'Simple and streamlined experiences allow people to stay focused on what matters most.',
  },
]

const BeliefsSection: FC = () => (
  <GradientSection title="Built with these beliefs" items={items} variant="reversed" />
)

export default BeliefsSection
